export const COOKIEYES_CONSENT_EVENT = 'cookieyes_consent_update';

export const COOKIEYES_CATEGORY = {
  analytics: 'analytics',
  advertisement: 'advertisement',
} as const;

export interface CookieYesConsentDetail {
  accepted?: string[];
  rejected?: string[];
}

export const readStoredCookieYesConsent = (): string[] => {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith('cookieyes-consent='));

  if (!match) {
    return [];
  }

  return decodeURIComponent(match.split('=')[1] ?? '')
    .split(',')
    .filter((pair) => pair.split(':')[1] === 'yes')
    .map((pair) => pair.split(':')[0]);
};

export const subscribeToCookieYesConsent = (
  listener: (accepted: string[]) => void
): (() => void) => {
  const handler = (event: Event) => {
    const detail = (event as CustomEvent<CookieYesConsentDetail>).detail;
    listener(detail?.accepted ?? []);
  };

  document.addEventListener(COOKIEYES_CONSENT_EVENT, handler);

  return () => {
    document.removeEventListener(COOKIEYES_CONSENT_EVENT, handler);
  };
};
